import * as React from 'react'
import { FC, useContext } from 'react'
import { TitleContext } from '../TitleDetails'
import Section from '../fragments/Section'
import ComingSoon from '../fragments/ComingSoon'

import './EventRSVP.scss'

const EventRSVP: FC = () => {
    const context = useContext(TitleContext)

    return (
        <Section id="event-rsvp" className="EventRSVP" style={{ minHeight: context.sectionMinHeight }}>
            {context.titleData.rsvpComingSoon ?
                <ComingSoon /> :
                <h1>Event RSVP</h1>
            }
        </Section>
    )
}

export default EventRSVP
